import styled from "styled-components";

const LocationContainer = styled.div.attrs({
  className: "tertiary-header",
})``;

export default LocationContainer;
